import { Box, Circle, HStack, Image, Skeleton, Text } from '@chakra-ui/react';
import ReactPlayer from 'react-player';
import { useCheckVimeoTranscode } from '../firebase';
import videoIcon from '../resources/video.svg';
interface VideoProps {
    pid?: string;
    videoUrl?: string;
    videoUrlSet?: boolean;
    loading: boolean;
}

export default function Video(props: VideoProps) {
    const { videoUrlSet, videoUrl, pid } = props;
    const { status, error, data } = useCheckVimeoTranscode(pid);
    const transcodeStatus = data?.status ?? '';
    if (!videoUrlSet) {
        return <></>;
    }
    const element =
        videoUrlSet && transcodeStatus === 'complete' ? (
            <Box className="videoWrap">
                <ReactPlayer
                    className="videoPlayer"
                    url={videoUrlSet && videoUrl ? videoUrl : ''}
                    controls={true}
                />
            </Box>
        ) : (
            <Skeleton isLoaded={status === 'success'}>
                <Box
                    bg={'midnight.25'}
                    borderRadius={{ lg: 'xl' }}
                    border="1px solid #EEEDF2"
                    mt="1em"
                >
                    <HStack height="298px" pl="3em" pr="3em">
                        <Circle borderWidth="3px" borderColor="midnight.75" mr="3em">
                            <Image height="58px" src={videoIcon} alt="video processing"></Image>
                        </Circle>
                        <Box>
                            <Text fontSize="xl" fontWeight="600">
                                Your video is processing
                            </Text>
                            <Text>
                                Refresh the page and check back soon to see your intro video live on
                                your profile.
                            </Text>
                        </Box>
                    </HStack>
                </Box>
            </Skeleton>
        );
    return element;
}
